import { Link } from 'react-router-dom';
import { usePortalTreatmentCourses } from '@/hooks/usePortalTreatmentCourses';
import { portalCourseForloebProgress } from '@/lib/courseStepSlotPicker';
import { PortalPageHead } from '@/components/portal/PortalChrome';

export function PortalTreatmentCourses() {
  const { data: courses = [], isLoading, error } = usePortalTreatmentCourses();
  const visible = courses.filter((course) => course.status !== 'cancelled');

  return (
    <>
      <PortalPageHead title="Forløb" subtitle="Dine behandlingsforløb hos klinikken." />
      {isLoading ? (
        <section className="card">
          <p className="help">Henter forløb…</p>
        </section>
      ) : error ? (
        <section className="card">
          <p className="help">Forløbene kunne ikke hentes. Prøv igen.</p>
        </section>
      ) : visible.length === 0 ? (
        <section className="card">
          <p className="help">Du har ingen behandlingsforløb endnu.</p>
        </section>
      ) : (
        visible.map((course) => {
          const progress = portalCourseForloebProgress(course.steps);
          return (
            <section key={course.id} className="card" style={{ marginBottom: 16 }}>
              <div className="card-h">
                <h2>{course.template_name}</h2>
                <span className={`chip ${course.status === 'active' ? 'chip-teal' : 'chip-neutral'}`}>
                  {course.status === 'active' ? 'Aktiv' : 'Afsluttet'}
                </span>
                <div className="r">
                  <Link to={`/portal/treatment-courses/${course.id}`} className="link" style={{ fontSize: 14 }}>
                    Se forløb
                  </Link>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginTop: 12 }}>
                <div className="segbar" style={{ flex: 1, maxWidth: 420 }}>
                  {course.steps.map((step, index) => (
                    <i
                      key={step.id}
                      className={step.status === 'completed' ? 'd' : index === progress.n - 1 ? 'n' : undefined}
                    />
                  ))}
                </div>
                <b style={{ fontSize: 14, whiteSpace: 'nowrap' }}>
                  {progress.completed} af {progress.total} trin gennemført
                </b>
              </div>
            </section>
          );
        })
      )}
    </>
  );
}
